<template>
    <div v-if="homePageData">
        <Products :images="[homePageData.slider_first_image_url, homePageData.slider_second_image_url, homePageData.slider_third_image_url]"
                  :imagesMobile="[homePageData.slider_first_mobile_image_url, homePageData.slider_second_mobile_image_url, homePageData.slider_third_mobile_image_url]"
                  :texts="[homePageData.slider_first_text, homePageData.slider_second_text, homePageData.slider_third_text]" />
        <Betefits :text="homePageData.why_trimm_text" />
        <Categories />
        <Story :text="homePageData.story_text" :img="homePageData.story_image_url" />
        <Blog />
    </div>
</template>

<script>
    import Products from '@/components/views/main-page/products.vue';
    import Betefits from '@/components/views/main-page/benefits.vue';
    import Categories from '@/components/views/main-page/categories.vue';
    import Story from '@/components/views/main-page/story.vue';
    import Blog from '@/components/views/main-page/blog.vue';
    import { commonService } from '@/services';

    export default {
        name: 'main-page',

        components: {
            Products,
            Betefits,
            Categories,
            Story,
            Blog
        },

        data() {
            return {
                homePageData: null
            }
        },

        async mounted() {
            this.$root.showOverlay();

            this.homePageData = await commonService.getHomePageData();

            this.$root.hideOverlay();
        }
    };
</script>